import {useId} from "react";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Text} from "@pg-design/text-module";
import {PRICES_CITIES} from "@pg-rp/navigation";

import {trackPricesHubPopularLocationClick} from "../../tracking/track_prices_hub_popular_location_click";
import {getCityLink} from "../../utils/get_city_link";
import {PricesHubViewSectionTracker} from "./PricesHubViewSectionTracker";

export const PricesHubLinks = () => {
    const headingId = useId();

    return (
        <section className={sectionStyle} aria-labelledby={headingId}>
            <PricesHubViewSectionTracker sectionName="popular_locations" />

            <Container maxWidthVariant="lg">
                <div className={innerStyle}>
                    <Text id={headingId} as="h2" variant="headline_3" className={headingStyle}>
                        Popularne lokalizacje
                    </Text>

                    <ul className={listStyle}>
                        {PRICES_CITIES.map((city) => (
                            <li key={city.slug} className={itemStyle}>
                                <a
                                    href={getCityLink(city.slug)}
                                    className={linkStyle}
                                    onClick={() => trackPricesHubPopularLocationClick({name: city.name, slug: city.slug})}
                                >
                                    <Text as="span" variant="body_copy_1">
                                        Ceny mieszkań {city.name}
                                    </Text>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </Container>
        </section>
    );
};

const sectionStyle = css({
    py: 6,
    backgroundColor: "var(--colors-white)",

    md: {
        py: 9
    }
});

const innerStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,

    md: {
        gap: 3
    }
});

const headingStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});

const listStyle = css({
    margin: 0,
    padding: 0,
    columnGap: 3,
    listStyle: "none",

    sm: {
        columnCount: 2
    },

    md: {
        columnCount: 3
    },

    lg: {
        columnCount: 4
    }
});

const itemStyle = css({
    breakInside: "avoid",
    marginBottom: 1
});

const linkStyle = css({
    color: "var(--colors-gray-700)",
    textDecoration: "none",

    _hover: {
        color: "var(--colors-secondary)",
        textDecoration: "underline"
    },

    _focusVisible: {
        outline: "2px solid var(--colors-primary)",
        outlineOffset: "2px"
    }
});
import {useId} from "react";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Text} from "@pg-design/text-module";
import {PRICES_CITIES} from "@pg-rp/navigation";

import {trackPricesHubPopularLocationClick} from "../../tracking/track_prices_hub_popular_location_click";
import {getCityLink} from "../../utils/get_city_link";
import {PricesHubViewSectionTracker} from "./PricesHubViewSectionTracker";

export const PricesHubLinks = () => {
    const headingId = useId();

    return (
        <section className={sectionStyle} aria-labelledby={headingId}>
            <PricesHubViewSectionTracker sectionName="popular_locations" />

            <Container maxWidthVariant="lg">
                <div className={innerStyle}>
                    <Text id={headingId} as="h2" variant="headline_3" className={headingStyle}>
                        Popularne lokalizacje
                    </Text>

                    <ul className={listStyle}>
                        {PRICES_CITIES.map((city) => (
                            <li key={city.slug} className={itemStyle}>
                                <a
                                    href={getCityLink(city.slug)}
                                    className={linkStyle}
                                    onClick={() => trackPricesHubPopularLocationClick({name: city.name, slug: city.slug})}
                                >
                                    <Text as="span" variant="body_copy_1">
                                        Ceny mieszkań {city.name}
                                    </Text>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </Container>
        </section>
    );
};

const sectionStyle = css({
    py: 6,
    backgroundColor: "var(--colors-white)",

    md: {
        py: 9
    }
});

const innerStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,

    md: {
        gap: 3
    }
});

const headingStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});

const listStyle = css({
    margin: 0,
    padding: 0,
    columnGap: 3,
    listStyle: "none",

    sm: {
        columnCount: 2
    },

    md: {
        columnCount: 3
    },

    lg: {
        columnCount: 4
    }
});

const itemStyle = css({
    breakInside: "avoid",
    marginBottom: 1
});

const linkStyle = css({
    color: "var(--colors-gray-700)",
    textDecoration: "none",

    _hover: {
        color: "var(--colors-secondary)",
        textDecoration: "underline"
    },

    _focusVisible: {
        outline: "2px solid var(--colors-primary)",
        outlineOffset: "2px"
    }
});
